import React from 'react';

function FormPage4(props) {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '40vh', padding: '2rem 0' }}>
            <div className="d-flex border rounded p-3 p-md-4 w-100 bg-white shadow-sm" style={{ maxWidth: '600px' }}>
                <div className="flex-fill">
                    <div className="fw-bold fs-5 lh-base">
                        YOUR CAR<br />
                        HAS BEEN<br />
                        SUCCESSFULLY<br />
                        SUBMITTED.
                    </div>
                </div>
                <div className="flex-fill ps-3 ps-md-4">
                    <div className="text-muted" style={{ fontSize: '0.95rem' }}>
                        Please follow SMS<br />
                        instructions to<br />
                        download the app and<br />
                        manage your listing.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormPage4;
